export default __webpack_public_path__ + "static/media/token.f5cfdcfe.webp";